import { unknownFreeBusy } from 'owa-locstrings/lib/strings/unknownfreebusy.locstring.json';
import { locationSuggestionNotAvailable } from 'owa-locstrings/lib/strings/locationsuggestionnotavailable.locstring.json';
import { locationSuggestionRecurringAvailability } from 'owa-locstrings/lib/strings/locationsuggestionrecurringavailability.locstring.json';
import { locationSuggestionRecurringPartialAvailability } from 'owa-locstrings/lib/strings/locationsuggestionrecurringpartialavailability.locstring.json';
import { availableFreeBusy } from 'owa-locstrings/lib/strings/availablefreebusy.locstring.json';
import { showAsBusy } from 'owa-locstrings/lib/strings/showasbusy.locstring.json';
import loc, { format } from 'owa-localize';
import { LocationPersonaControlViewState } from 'owa-location-persona';

export default function getAvailabilityTextAndStyle(
    locationResult: LocationPersonaControlViewState,
    styles: any
): any {
    let freebusyStyle = styles.availabilityUnknown;
    let freebusyText = loc(unknownFreeBusy);

    if (locationResult.availability) {
        switch (locationResult.availability) {
            case 'Free':
                freebusyText = loc(availableFreeBusy);
                freebusyStyle = styles.availabilityFree;
                break;
            case 'Busy':
                freebusyText = loc(showAsBusy);
                freebusyStyle = styles.availabilityBusy;
                break;
        }
    }

    if (locationResult.totalNumberOfTimeSlots) {
        if (locationResult.totalNumberOfTimeSlots - locationResult.numberOfAvailableTimeSlots > 2) {
            freebusyText = loc(locationSuggestionNotAvailable);
            freebusyStyle = styles.availabilityBusy;
        } else if (
            locationResult.numberOfAvailableTimeSlots == locationResult.totalNumberOfTimeSlots &&
            !locationResult.isPartialAvailability
        ) {
            freebusyText = loc(availableFreeBusy);
            freebusyStyle = styles.availabilityFree;
        } else {
            const availabilityStringFormat = locationResult.isPartialAvailability
                ? loc(locationSuggestionRecurringPartialAvailability)
                : loc(locationSuggestionRecurringAvailability);
            freebusyText = format(
                availabilityStringFormat,
                locationResult.numberOfAvailableTimeSlots,
                locationResult.totalNumberOfTimeSlots
            );
            freebusyStyle = styles.availabilityFree;
        }
    }

    return { freebusyText, freebusyStyle };
}
